import React, { useState, useEffect } from "react";
import axios from "axios";
import { BsUpload, BsTrash } from "react-icons/bs";
import toast from "react-hot-toast";
import { URLApi } from "../../../services/api_function";

function Bannerpanel() {
  const [image, setImage] = useState(null);
  const [preview, setPreview] = useState("");
  const [uploadedImages, setUploadedImages] = useState([]);
  const [uploadLocation, setUploadLocation] = useState("home"); // default

  useEffect(() => {
    fetchUploadedImages();
  }, []);

  const fetchUploadedImages = async () => {
    try {
      const res = await axios.get(`${URLApi}/Banneruploaded-images`);
      // Normalize to match the format expected in the component
      const formatted = res.data.map((img) => ({
        _id: img._id,
        url: img.imageUrl,
      }));
      console.log(
        formatted,
        "This is the all the image s that are present in the database"
      );
      setUploadedImages(formatted);
    } catch (err) {
      console.error("Failed to fetch images:", err);
    }
  };

  const handleChange = (e) => {
    const file = e.target.files[0];
    setImage(file);
    setPreview(URL.createObjectURL(file));
  };

  const handleUpload = async () => {
    if (!image) return;

    console.log(
      uploadLocation,
      "This is called the image location at which slide it is uploaded"
    );
    const formData = new FormData();
    formData.append("image", image);
    formData.append("location", uploadLocation); // Pass location

    try {
      const res = await axios.post(
        `${URLApi}/banner-upload`,
        formData
      );
      if (res.data.status === 400) {
        toast.error(res.data.message);
        return;
      }
      toast.success("Image uploaded successfully!");
      setImage(null);
      setPreview("");
      fetchUploadedImages();
    } catch (err) {
      console.error(err);
      alert("Upload failed");
    }
  };

  const handleDelete = async (id) => {
    try {
      await axios.delete(`${URLApi}/deletebanner-image/${id}`);
      setUploadedImages((prev) => prev.filter((img) => img._id !== id));
    } catch (err) {
      console.error("Delete failed:", err);
      alert("Failed to delete image");
    }
  };

  return (
    <div className="container py-5">
      <div className="card shadow-lg p-4 mx-auto" style={{ maxWidth: "500px" }}>
        <h3 className="text-center mb-4">Admin Panel - Upload Image</h3>

        <div className="mb-3">
          <label className="form-label">Choose Image</label>
          <input
            type="file"
            className="form-control"
            accept="image/*"
            onChange={handleChange}
          />
          {/* <div className="mb-3">
            <label className="form-label d-block py-2">
              Select Upload Location:
            </label>
            <div className="form-check form-check-inline">
              <input
                className="form-check-input"
                type="radio"
                name="uploadLocation"
                id="1"
                value="1"
                checked={uploadLocation === "1"}
                onChange={(e) => setUploadLocation(e.target.value)}
              />
              <label className="form-check-label" htmlFor="home">
                Slide1
              </label>
            </div>
            <div className="form-check form-check-inline">
              <input
                className="form-check-input"
                type="radio"
                name="uploadLocation"
                id="2"
                value="2"
                checked={uploadLocation === "2"}
                onChange={(e) => setUploadLocation(e.target.value)}
              />
              <label className="form-check-label" htmlFor="gallery">
                Slide2
              </label>
            </div>
            <div className="form-check form-check-inline">
              <input
                className="form-check-input"
                type="radio"
                name="uploadLocation"
                id="3"
                value="3"
                checked={uploadLocation === "3"}
                onChange={(e) => setUploadLocation(e.target.value)}
              />
              <label className="form-check-label" htmlFor="about">
                Slide3
              </label>
            </div>
          </div> */}
        </div>

        {preview && (
          <div className="text-center mb-3">
            <img
              src={preview}
              alt="Preview"
              className="img-thumbnail"
              style={{ maxHeight: "250px" }}
            />
          </div>
        )}

        <div className="d-grid">
          <button
            className="btn btn-primary"
            onClick={handleUpload}
            disabled={!image}
          >
            <BsUpload className="me-2" /> Upload
          </button>
        </div>
      </div>

      {/* Uploaded Images Section */}
      <div className="mt-5">
  <h5 className="mb-3">Banner Uploaded Images</h5>

  {uploadedImages.length === 0 ? (
    <div className="text-center p-5 border rounded shadow-sm bg-light">
      <img
        src="https://cdn-icons-png.flaticon.com/512/4076/4076549.png"
        alt="No data"
        width={100}
        className="mb-3"
      />
      <h6 className="text-muted">No images or updates yet</h6>
    </div>
  ) : (
    <div className="row">
      {uploadedImages.map((img) => (
        <div className="col-md-4 mb-4" key={img._id}>
          <div className="card">
            <img
              src={img.url}
              className="card-img-top"
              alt="Uploaded"
              height={250}
            />
            <div className="card-body text-center">
              <button
                className="btn btn-outline-danger btn-sm"
                onClick={() => handleDelete(img._id)}
              >
                <BsTrash className="me-1" /> Delete
              </button>
            </div>
          </div>
        </div>
      ))}
    </div>
  )}
</div>

    </div>
  );
}

export default Bannerpanel;
